export default __webpack_public_path__ + "static/media/pic01.97500428.jpg";